// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.practicepay.PracticePayStoredPaymentMethodResponse */
/* istanbul ignore next */
@GandalfModel
export class PracticePayStoredPaymentMethodResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	brand!: string | null;

	@GandalfProperty({ designType: String })
	expiryMonth!: string | null;

	@GandalfProperty({ designType: String })
	expiryYear!: string | null;

	@GandalfProperty({ designType: String })
	holderName!: string | null;

	@GandalfProperty({ designType: String })
	id!: string | null;

	@GandalfProperty({ designType: Boolean })
	isDefault!: boolean;

	@GandalfProperty({ designType: String })
	lastFour!: string | null;

	@GandalfProperty({ designType: String })
	type!: string | null;

}
